<script setup lang="ts">

const props = defineProps<{loading?: boolean}>();

const slots = useSlots();

const hasSlot = (name: string): boolean => {
    return !!slots[name];
};

</script>

<template>
    <div v-if="props.loading" class="w-full text-center pt-4">
        <div v-if="hasSlot('indicator')">
            <slot name="indicator" />
        </div>
        <VLProgressSpinner v-else />
    </div>

    <slot
        v-else
        name="default"
    />
</template>
